<template>
  <div>
    <a-text-field
      varName="client_name"
      varLabel="Client Name"
      :varRequired="true"
      :varInitial="data.client_name"
      :formLayout="formLayout"
      :size="size"
    />
    <a-text-area-field
      varName="client_description"
      varLabel="Client Description"
      :varRequired="true"
      :varInitial="data.client_description"
      :formLayout="formLayout"
      :size="size"
    />
    <a-text-clipboard-field
      varName="client_id"
      varLabel="Client ID"
      :varRequired="true"
      :varInitial="data.client_id"
      :formLayout="formLayout"
      :size="size"
      :disabled="true"
      :value="data.client_id"
    />
    <a-text-clipboard-field
      v-if="data.client_secret"
      varName="client_secret"
      varLabel="Client Secret"
      :varRequired="true"
      :varInitial="data.client_secret"
      :formLayout="formLayout"
      :size="size"
      :disabled="true"
      :value="data.client_secret"
      varType="password"
    />
    <a-select-field
      varName="application_type"
      varLabel="Application Type"
      :varRequired="true"
      :varInitial="data.application_type"
      :formLayout="formLayout"
      :size="size"
      :varOptions="options.application_type.choices"
      type="schema"
      :disabled="true"
    />
    <a-switch-field
      varName="is_first_party"
      varLabel="First Party"
      :varRequired="true"
      :varInitial="data.is_first_party"
      :formLayout="formLayout"
      :size="size"
      :disabled="true"
      description="First party apps can skip the consent screen"
    />
    <a-select-field
      varName="consent_prompt"
      varLabel="Consent Prompt"
      :varRequired="true"
      :varInitial="data.consent_prompt"
      :formLayout="formLayout"
      :size="size"
      :varOptions="consent_prompt_types"
      type="schema"
      :disabled="true"
      v-show="!data.is_first_party"
    />
    <a-select-field
      varName="grant_types"
      varLabel="Grant Types"
      :varRequired="true"
      :varInitial="data.grant_types"
      :formLayout="formLayout"
      :size="size"
      :varOptions="options.grant_types.choices"
      type="schema"
      varMode="multiple"
      :disabled="false"
    />
    <a-select-field
      varName="response_types"
      varLabel="Response Types"
      :varRequired="true"
      :varInitial="data.response_types"
      :formLayout="formLayout"
      :size="size"
      :varOptions="response_types"
      type="array"
      varMode="multiple"
      :disabled="false"
    />
    <a-select-field
      varName="token_endpoint_auth_method"
      varLabel="Authentication Method"
      :varRequired="true"
      :varInitial="data.token_endpoint_auth_method"
      :formLayout="formLayout"
      :size="size"
      :varOptions="options.token_endpoint_auth_method.choices"
      type="schema"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      response_types: [
        "code",
        "id_token",
        "token",
        "id_token token",
        "code id_token",
        "code token",
        "code id_token token",
        "none"
      ],
      consent_prompt_types: [
        {
          value: "always",
          display_name: "Always prompt a user for consent"
        },
        {
          value: "once",
          display_name: "Prompt user for consent once and remember"
        }
      ]
    };
  },
  components: {},
  props: {
    formLayout: String,
    size: String,
    data: Object,
    options: Object
  }
};
</script>
